




































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetBackupList,
  AddBackup,
  UpdateStrength,
  GetUserData,
} from "@/request/common";
import LeftNav from "../components/setting-nav.vue";
@Component({
  components: {
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private cTab: any = "数据备份";
  private data: any = [];
  private strengthData: any = {};
  private ifShowEdit: any = false;
  private name: any = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private restore(row: any) {
    this.$message.success("还原成功");
  }
  private openEdit() {
    this.name = "";
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.name) {
      this.$message.warning("请输入备份名称");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      名称: this.name,
      状态: "备份完成",
      备份类型: "手动备份",
    };
    AddBackup(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("创建成功");
        this.getList();
        this.ifShowEdit = false;
      })
      .catch(() => {
        loading.close();
      });
  }
  private resetStrength() {
    this.strengthData = {
      浮: 60,
      中: 120,
      沉: 180,
      重沉: 240,
    };
    this.strengthSure();
  }
  private strengthSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      target_user_id: this.user.user_id,
      取脉力度: this.strengthData,
    };
    UpdateStrength(this, params, loading).then((res: any) => {
      loading.close();
      this.$message.success("保存成功");
      this.getUserData();
    });
  }
  private getUserData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetUserData(this, loading).then((res: any) => {
      loading.close();
      this.$store.commit("updateUser", res);
    });
  }
  private changeTab(val: any) {
    this.cTab = val;
    if (val == "取脉力度调节") {
      this.strengthData = JSON.parse(JSON.stringify(this.user["取脉力度"]));
    }
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetBackupList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.getList();
  }
}
